import { render, staticRenderFns } from "./LinkedCustomInvestorGoalBudgetBodyCard.vue?vue&type=template&id=21b5a24c&scoped=true&"
import script from "./LinkedCustomInvestorGoalBudgetBodyCard.vue?vue&type=script&lang=ts&"
export * from "./LinkedCustomInvestorGoalBudgetBodyCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b5a24c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VIcon,VRow})
